<template>
  <div id="quienes">
    <div class="section">
      <div
        class="container fadeInUp wow"
        data-wow-duration="0.5s"
      >
        <h3>Nosotros</h3>
        <div class="line bg-primary"></div>
        <p class="my-5">
          <b>CJARA</b> CJARA Inspección Técnica es una empresa de Servicios para el sector Construcción. Contamos con capacidades para entregar a nuestros Mandantes un servicio de Gerenciamiento e Inspección Técnica de Proyectos desde su pre factibilidad hasta su diseño con sus especialidades y su CAPEX, su construcción y puesta en marcha.
        </p>
      </div>
    </div>
  </div>
</template>

<style lang="scss"></style>
<script>
export default {
  name: "Quienes",
};
</script>
